import React, { memo, useCallback, useEffect, useState } from 'react'
import styles from './ProductBrowserPage.module.scss'
import RecommendationParameterOverview from './components/RecommendationParameterOverview'
import RecommendationProductOptions from './components/RecommendationProductOptions'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../../stores/store'
import { recommendProducts, recommendedAlready } from '../../../stores/slices/solar-recommendation-slice'
import { toast } from 'react-toastify'
import CommonLoadingSpinner from '../../../common/components/loading-spinner/CommonLoadingSpinnerForPage'

type Props = {}

const ProductBrowserPage: React.FC<Props> = memo((props: Props) => {
    const dispatch = useDispatch<AppDispatch>();
    const [loading, setLoading] = useState<boolean>(false)

    const recommended = useSelector(recommendedAlready)

    const recommendFetch = useCallback(async () => {
        setLoading(true)
        const result = await dispatch(recommendProducts({
            page: 1,
            pageSize: 6,
          }))
      
        if (!recommendProducts.fulfilled.match(result)) {
            toast.error('There was an error recommending the products');
        }
    }, [dispatch]);
    
    useEffect(() => {
        if(!recommended){
            recommendFetch().finally(() => setLoading(false))
        }
    }, [recommendFetch, recommended])

    return (
        <CommonLoadingSpinner loading={loading}>
            <div className={styles.headerContainer}>
                Tailored Product Recommendations from Your Data
            </div>
            <div className={styles.contentContainer}>
                <RecommendationParameterOverview />
                <RecommendationProductOptions />
            </div>
        </CommonLoadingSpinner>
    )
})

export default ProductBrowserPage